/** Field helpers shared by the builder sections: the error line under a field and the aria wiring to it. */

import React from 'react';
import { fieldId } from '../planDraft';
import { errorTextStyle } from '../formStyles';

/** Looks up the message to show under a field (only once the seller has left it, or asked to see it). */
export type ErrorFor = (field: string) => string | undefined;

export const errorId = (field: string): string => `${fieldId(field)}-error`;

/** aria props for an input: invalid + described by its error line and any hint. */
export function fieldAria(field: string, error: string | undefined, hintId?: string): { 'aria-invalid'?: true; 'aria-describedby'?: string } {
  const describedBy = [error ? errorId(field) : null, hintId].filter(Boolean).join(' ');
  return { 'aria-invalid': error ? true : undefined, 'aria-describedby': describedBy || undefined };
}

export const FieldError: React.FC<{ field: string; message?: string }> = ({ field, message }) =>
  message ? (
    <div id={errorId(field)} style={errorTextStyle}>
      {message}
    </div>
  ) : null;

/** "(optional)" after a label, in sentence case. */
export const Optional: React.FC<{ children?: React.ReactNode }> = ({ children = 'optional' }) => (
  <span style={{ fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>({children})</span>
);
